import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import {
  ROOMESSENTAILLIST,
  ROOMESSENTIALREMOVE,
} from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";
import { Link } from "react-router-dom";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";
import { useTranslation } from "react-i18next";

const RoomAmenity = () => {
  const { t } = useTranslation();
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: ROOMESSENTAILLIST,
  });

  const column = [
    {
      head: t("roomAmenity.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: t("roomAmenity.columns.image"),
      accessor: "imgUrl",
      component: (item, idx) => {
        return (
          <>
            <span className="w-25 h-25">
              <img
                style={{ height: "50px", width: "50px" }}
                src={item?.imgUrl}
                alt=""
              />
            </span>
          </>
        );
      },
    },
    {
      head: t("roomAmenity.columns.name"),
      accessor: "name",
    },
    {
      head: t("roomAmenity.columns.createdAt"),
      accessor: "createdAt",
      component: (item, key) => {
        return (
          <>
            <p>{item.createdAt ? moment(item.createdAt).format("MM-DD-YYYY") : "-"}</p>
          </>
        );
      },
    },
    {
      head: t("roomAmenity.columns.status"),
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span
          className={`px-2 py-0 rounded ${
            item?.status === "Active"
              ? "bg-success text-white"
              : "bg-danger text-white"
          }`}
        >
          {item?.status === "Active" 
            ? t("roomAmenity.status.active") 
            : t("roomAmenity.status.inactive")}
        </span>
      ),
    },
    {
      head: t("roomAmenity.columns.action"),
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/roomamenity/edit/${item._id}`}
            viewLink={`/roomamenity/detail/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);

  console.log(deleteModel,"deleteModel=======<>")

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => ROOMESSENTIALREMOVE({ _id: deleteModel.dumpId }))
        }
      />

      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("roomAmenity.title")}
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <Link
                    to="/roomamenity/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("roomAmenity.buttons.addNew")}
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RoomAmenity;